import { setProductType } from "@redux/slices/appStateSlice";
import { ProductCategory } from "@utils/constants";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

const useChangeProductType = (
  productType: ProductCategory = ProductCategory.DEFAULT
) => {
  const dispatch = useDispatch();
  const productSet: Set<string> = new Set();
  productSet.add(ProductCategory.DIAMOND);
  productSet.add(ProductCategory.GEMSTONE);
  productSet.add(ProductCategory.JEWELRY);
  productSet.add(ProductCategory.LAB_GROWN_DIAMOND);

  if (!productSet.has(productType)) productType = ProductCategory.DEFAULT;

  useEffect(() => {
    dispatch(setProductType(productType));
  }, [productType]);
};

export default useChangeProductType;
